<div *ngIf="customer">
  <div class="customer" [ngStyle]="{ backgroundColor: customer.color, color: customer.colorType === 'light' ? 'black' : 'white' }">
    <div class="name">{{ customer.name }}</div>
    <div class="amount">{{ customer.amount }}</div>
  </div>
</div>
